import React from "react"
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-intl"

const languageName = {
  ro: "RO",
  de: "DE",
}

const Language = () => (
  <div>
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) =>
        languages.map(language => (
          <a
            key={language}
            onClick={() => changeLocale(language)}
            onKeyDown={() => changeLocale(language)}
            style={{
              fontWeight: currentLocale === language ? `bold` : `normal`,
              color: `white`,
              cursor: `pointer`,
              paddingLeft: `2rem`,
            }}
            className="nav-link"
            href={() => changeLocale(language)}
          >
            {languageName[language]}
          </a>
        ))
      }
    </IntlContextConsumer>
  </div>
)

export default Language
